/**
 * Feedback visual ao adicionar um item ao carrinho.
 *
 * Antes: clique → request → toast no topo da tela. O usuário não sabia que
 * o clique foi captado até o toast aparecer — sensação "brusca" / sem
 * feedback no ponto do clique.
 *
 * Agora: clique → botão dá uma "batida" (pulse + check verde sobreposto) e
 * o ícone do carrinho no header balança. O toast continua, mas vira
 * confirmação textual de algo que já foi visualmente comunicado.
 *
 * Respeitando `prefers-reduced-motion`: aplica só a classe de check sem
 * animação de escala/rotação (CSS decide via @media).
 *
 * Uso:
 *   try {
 *     await cartStore.add(p.id, 1);
 *     cartAddFeedback.success(e.currentTarget as HTMLElement);
 *     app.alerts.show(...);
 *   }
 */

const ADD_BTN_CLASS = 'MpAdd--success';
const CART_ICON_CLASS = 'MpCartIcon--bump';
const ADD_BTN_DURATION_MS = 900;
const CART_ICON_DURATION_MS = 600;
function restart(el, cls, durationMs) {
  el.classList.remove(cls);
  // Força reflow pra que a animação reinicie mesmo em cliques rápidos
  // sucessivos no mesmo botão.
  void el.offsetWidth;
  el.classList.add(cls);
  window.setTimeout(() => el.classList.remove(cls), durationMs);
}
export const cartAddFeedback = {
  /** Feedback no botão que disparou o add + bump no ícone do carrinho. */
  success(btn) {
    if (btn) restart(btn, ADD_BTN_CLASS, ADD_BTN_DURATION_MS);

    // Procura o ícone do carrinho no header (Flarum coloca o CartDropdown
    // dentro de .HeaderSecondary; fallback pra qualquer .CartDropdown).
    // Scope ao .HeaderSecondary primeiro pra não pegar instâncias do
    // dropdown que aparecem em outros lugares (mobile drawer, modal-open
    // duplicate). Se HeaderSecondary não existir (admin panel), fallback
    // pro document — mas o caller só dispara desse path no forum side.
    const root = document.querySelector('#header-secondary') || document;
    const cartIcon = root.querySelector('.CartDropdown .Button-icon') || root.querySelector('.CartDropdown i.fa-shopping-cart');
    if (cartIcon) restart(cartIcon, CART_ICON_CLASS, CART_ICON_DURATION_MS);
  }
};
flarum.reg.add('ramon-marketplace', 'common/utils/cartAddFeedback', { cartAddFeedback: cartAddFeedback, });